const sortFilterApiAdapter = (sortFilterValues) => {
  const filters = {
    relevancy: {
      SortField: 'Relevancy',
      SortDescending: true,
    },
    mostRecent: {
      SortField: 'PublishedDate',
      SortDescending: true,
    },
    nameAZ: {
      SortField: 'Name',
      SortDescending: false,
    },
    nameZA: {
      SortField: 'Name',
      SortDescending: true,
    },
  };

  return filters[sortFilterValues.criteria] || filters.relevancy;
};

export default sortFilterApiAdapter;
